import cloneDeep from 'lodash/cloneDeep';
import sortBy from 'lodash/sortBy';
import includes from 'lodash/includes';

/**
 * @param  {Array} bundles
 * @return {Object}  returns object containing total products per tier, combined tiers, and overall
 */

export default (bundles) => {
  let deliveredGameCount = 0;
  const productTypes = { total: { all: 0 }, tiers: [], tiersTotal: [], containsOverride: false };

  const bundleTiers = cloneDeep(bundles);

  bundleTiers.forEach((tier, index) => {
    productTypes.tiers.push({});
    productTypes.tiersTotal.push({});

    let tierDeliveryOverride = false;
    if (tier.deliveredProducts && tier.deliveredProducts > 0) {
      productTypes.containsOverride = true;

      tierDeliveryOverride = true;
      deliveredGameCount += tier.deliveredProducts;
    }

    // Calculate what product types are included in the bundle, and how many products there are in each type for the whole bundle.
    sortBy(tier.games, ['sort_order']).filter(game => game.display).forEach((game) => {
      if (!tierDeliveryOverride) {
        if (game.files) {
          deliveredGameCount += Number(game.files);
        } else {
          deliveredGameCount += 1;
        }
      }

      // Create an object for the total amount of each type of product in the bundle.
      // If 'files' are provided (e.g. the number of comic downloads for an item), use that. Otherwise increment by 1.
      if (productTypes.total[game.display_type]) {
        if (game.files) {
          productTypes.total[game.display_type] += Number(game.files);
        } else {
          productTypes.total[game.display_type] += 1;
        }
      }
      if (!productTypes.total[game.display_type]) {
        if (game.files) {
          productTypes.total[game.display_type] = Number(game.files);
        } else {
          productTypes.total[game.display_type] = 1;
        }
      }

      // Create an all count for the total bundle.
      if (game.files) {
        productTypes.total.all += Number(game.files);
      } else {
        productTypes.total.all += 1;
      }

      // Create a type count for the individual tiers.
      if (productTypes.tiers[index][game.display_type]) {
        if (game.files) {
          productTypes.tiers[index][game.display_type] += Number(game.files);
        } else {
          productTypes.tiers[index][game.display_type] += 1;
        }
      }
      if (!productTypes.tiers[index][game.display_type]) {
        if (game.files) {
          productTypes.tiers[index][game.display_type] = Number(game.files);
        } else {
          productTypes.tiers[index][game.display_type] = 1;
        }
      }

      // Create an all total for the tier.
      if (!productTypes.tiers[index].all) productTypes.tiers[index].all = 0;
      if (game.files) {
        productTypes.tiers[index].all += Number(game.files);
      } else {
        productTypes.tiers[index].all += 1;
      }

      // Tier override if provided.
      if (tier.deliveredProducts) {
        productTypes.tiers[index].override = tier.deliveredProducts;
      }
    });
  });

  // If the bundle contains a delivery override in any tier, update the total. discard the types and return a single total.
  // The override can't be split by type, therefore we can't display the number granularly.
  if (productTypes.containsOverride) {
    productTypes.total.override = deliveredGameCount;
  }

  // Create an array for the total amount of each type of product per tier combined.
  // Combinded tiers split it by type, all and override.
  const types = [];
  productTypes.tiers.forEach((tier, index) => {
    Object.keys(tier).forEach(t => !includes(types, t) && types.push(t));

    // First combined tier is the same as the first uncombined tier
    if (index === 0) {
      productTypes.tiersTotal[index] = productTypes.tiers[index];
    }

    // Working through the tiers, go through each type adding them up
    if (index !== 0 && index <= productTypes.tiers.length) {
      let individualItemCount = 0;

      types.forEach((type) => {
        const ammount = tier[type] || 0;

        if (type !== 'all') {
          individualItemCount += ammount;
        }

        // If the tier below contains products of the same type, add them to this tier.
        if (productTypes.tiersTotal[index - 1][type]) {
          productTypes.tiersTotal[index][type] = ammount + productTypes.tiersTotal[index - 1][type];
        } else {
          productTypes.tiersTotal[index][type] = ammount;
        }
      });

      // The below is for edge cases on tiered bundles when the override is used. This rarely happens.

      if (productTypes.containsOverride && productTypes.tiersTotal[index].override) {
        // If this tier DOES have an override but the tier below DOES NOT, add on the total number of games below.
        if (!productTypes.tiersTotal[index - 1].override) {
          productTypes.tiersTotal[index].override += productTypes.tiersTotal[index - 1].all; // eslint-disable-line max-len
        }

        // If the tier below DOES have an override, the override in this tier needs to be the one below plus all the games in this tier too (individualItemCount).
        if (productTypes.tiersTotal[index - 1].override) {
          productTypes.tiersTotal[index].override = productTypes.tiersTotal[index - 1].override + individualItemCount; // eslint-disable-line max-len
        }
      }
    }
  });

  return productTypes;
};
